///<reference path="../common/strategy-api-base.ts"/>


module Meevo.Components.Controls.SmartMover {
  import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

  import IReportManufacturers = Meevo.Plugins.Reports.IReportManufacturers;
  import IReportProductCategory = Meevo.Plugins.Reports.IReportProductCategory;

  interface IRes {
    manufacturerIds: string[];
    id: string;
    objectState: ObjectStateEnum;
    displayName: string;
    homeLocationId: number;
  }

  export class ProdCatManufacturersStrategy extends StrategyApiBase<IRes> implements ICollectionPopulate {

    constructor(
      productCategories: IApiCollection<IReportProductCategory>,
      manufacturers: IApiCollection<IReportManufacturers>,
      dataService: Meevo.Components.BaseClasses.IDataService,
      options: { criteria: _.Dictionary<any> }
    ) {
      super(productCategories, manufacturers, dataService, {
        url: '/Report/ProductCategory/Manufacturer',
        criteria: {
          businessTypeList: null,
          locationList: null,
          hierarchyId: null,
          branchId: null,
          objectStateEnumList: [ObjectStateEnum.Active],
          displayName: null,
          fieldOrderBy: 'DisplayName',
          orderAscDesc: 'Ascending',
          ...options.criteria
        }
      })
    }

    populateData(): void {
      if (this.parent.models.length === 0) {
        return;
      }

      for (const productCat of this.parent.models) {
        const row = this.result.find((resRow) => resRow.id === productCat.id);

        if (!row) continue;

        (<ISmartMoverCategoryModel<IReportManufacturers>>productCat).resetModels(
          this.child.models.filter(manufacturer => row.manufacturerIds.indexOf(manufacturer.id) !== -1)
        );
      }
    }
  }
}
